<style lang="less">
    @import "../../../styles/table.less";
    .name{
        color: #faad14;
    }
</style>
<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70">
                            <Form-item label="标题" prop="studentName">
                                <Input type="text" v-model="searchForm.studentName" placeholder="请输入标题" clearable style="width: 200px"/>
                            </Form-item>
                            <span v-if="drop">
                                <Form-item label="创建时间">
                                  <DatePicker v-model="selectDate" type="daterange" split-panels format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                                </Form-item>
                                <Form-item label="类型" prop="sliderType">
                                    <Select v-model="searchForm.sliderType" placeholder="请选分类" clearable style="width: 200px">
                                        <Option :value=1>APP轮播图</Option>
                                        <Option :value=2>PC首页轮播图</Option>
                                        <Option :value=3>APP启动图</Option>
                                        <Option :value=4>PC人才测评</Option>
                                        <Option :value=5>PC学分转换</Option>
                                        <Option :value=6>PC关于我们</Option>
                                        <Option :value=7>PC新闻中心</Option>
                                        <Option :value=8>PC帮助中心</Option>
                                        <Option :value=9>PC联系我们</Option>
                                        <Option :value=10>PC行业学院</Option>
                                        <Option :value=12>小程序轮播图</Option>
                                    </Select>
                                </Form-item>
                            </span>
                            <Form-item style="margin-left:-35px;" class="br">
                                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                                <Button @click="handleReset">重置</Button>
                                <a class="drop-down" @click="dropDown">{{dropDownContent}}
                                    <Icon :type="dropDownIcon"></Icon>
                                </a>
                            </Form-item>
                        </Form>
                    </Row>
                    <Row class="operation">
                        <Button @click="add" type="primary" icon="md-add">添加</Button>
                        <Button @click="delAll" icon="md-trash">批量删除</Button>
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                        <circleLoading v-if="operationLoading"/>
                    </Row>
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" sortable="custom" @on-sort-change="changeSort" @on-selection-change="showSelect" ref="table"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <slider-drawer ref="sliderDrawer"></slider-drawer>
    </div>
</template>

<script>
    import circleLoading from "../../my-components/circle-loading.vue";
    import {sliderList, delSlider, setSendStatus} from "@/api/index";
    export default {
        name: "slider-manage",
        components: {
            SliderDrawer: resolve => {require(['./slider-drawer.vue'], resolve)},
            circleLoading
        },
        data() {
            return {
                loading: false, // 表单加载状态
                operationLoading: false,
                drop: false,
                selectCount: 0, // 多选计数
                selectList: [], // 多选数据
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: {
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "createTime", // 默认排序字段
                    order: "desc", // 默认排序方式
                    studentName: "",
                    mobile: "",
                    startDate: "",
                    endDate: ""
                },
                selectDate: null, //选择日期绑定modal
                columns: [
                    {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "标题",
                        key: "sliderTitle",
                        width: 200,
                        sortable: true
                    }, {
                        title: "封面图",
                        key: "sliderImg",
                        width: 150,
                        align: "center",
                        render: (h, params) => {
                            return h("img", {
                                attrs: {
                                    src: params.row.sliderImg,
                                    alt: "加载图片失败"
                                },
                                style: {
                                    cursor: "pointer",
                                    width: "80px",
                                    height: "60px",
                                    margin: "10px 0",
                                    "object-fit": "contain"
                                },
                                on: {
                                    click: () => {

                                    }
                                }
                            });
                        }
                    }, {
                        title: "模块分类",
                        key: "sliderType",
                        align: "center",
                        width: 130,
                        render: (h, params) => {
                            let re = "";
                            if (params.row.sliderType === 1) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#FA79E7"
                                            }
                                        },
                                        "APP轮播图"
                                    )
                                ]);
                            } else if (params.row.sliderType === 2) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#FA1031"
                                            }
                                        },
                                        "PC首页轮播图"
                                    )
                                ]);
                            }else if (params.row.sliderType ===3) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#33DEFA"
                                            }
                                        },
                                        "APP启动图"
                                    )
                                ]);
                            }else if (params.row.sliderType ===4) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#faad14"
                                            }
                                        },
                                        "PC人才测评"
                                    )
                                ]);
                            }else if (params.row.sliderType ===5) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#A41FFA"
                                            }
                                        },
                                        "PC学分转换"
                                    )
                                ]);
                            }else if (params.row.sliderType ===6) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#8E98FA"
                                            }
                                        },
                                        "PC关于我们"
                                    )
                                ]);
                            }else if (params.row.sliderType ===7) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#2545FA"
                                            }
                                        },
                                        "PC新闻中心"
                                    )
                                ]);
                            }else if (params.row.sliderType ===8) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#FA6711"
                                            }
                                        },
                                        "PC帮助中心"
                                    )
                                ]);
                            }else if (params.row.sliderType ===9) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#FAD4AC"
                                            }
                                        },
                                        "PC联系我们"
                                    )
                                ]);
                            }else if (params.row.sliderType ===10) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#a782fa"
                                            }
                                        },
                                        "PC行业学院"
                                    )
                                ]);
                            }else if (params.row.sliderType ===11) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#32fa4b"
                                            }
                                        },
                                        "PC认证考试"
                                    )
                                ]);
                            }
                            else if (params.row.sliderType ===12) {
                                return h("div", [
                                    h(
                                        "Tag",
                                        {
                                            props: {
                                                color: "#8FBC8F"
                                            }
                                        },
                                        "小程序轮播图"
                                    )
                                ]);
                            }
                        }
                    },
                    {
                        title: "跳转方式",
                        key: "jumpType",
                        width: 115,
                        sortable: true,
                        render: (h, params) => {
                            let re = "";
                            if (params.row.jumpType ===1) {
                                re = "外部链接";
                            } else if (params.row.jumpType === 2) {
                                re = "内部模块";
                            }else if (params.row.jumpType === 3) {
                                re = "内部H5";
                            }else if (params.row.jumpType === 0) {
                                re = "无跳转";
                            }
                            return h("div", re);
                        }
                    },
                    {
                        title: "是否发布",
                        key: "sendStatus",
                        align: "center",
                        width: 120,
                        render: (h, params) => {
                            return h(
                                "i-switch",
                                {
                                    props: {
                                        value: params.row.sendStatus,
                                        size: "large",
                                        "true-value": 1,
                                        "false-value": 0
                                    },
                                    on: {
                                        "on-change": v => {
                                            this.setSendStatus(params.row,v);
                                        }
                                    }
                                },
                                [
                                    h("span", {slot: "open"}, "已发布"),
                                    h("span", {slot: "close"}, "未发布")
                                ]
                            );
                        }
                    },
                    {
                        title: "创建日期",
                        key: "createTime",
                        width: 150,
                        align: "center"
                    }, {
                        title: "操作",
                        key: "action",
                        width: 280,
                        align: "center",
                        fixed: "right",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            size: "small"
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small"
                                        },
                                        on: {
                                            click: () => {
                                                this.remove(params.row);
                                            }
                                        }
                                    },
                                    "删除"
                                )
                            ]);
                        }
                    }],
                data: [],
                total: 0
            }
        },
        methods: {
            init() {
                this.getDataList();
            },
            getDataList() {
                this.loading = true;
                sliderList(this.searchForm).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            getDataList2() {
                this.loading = true;
                sliderList().then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.data = res.data.rows;
                        this.total = res.data.total;
                    }
                });
            },
            //设置发布状态
            setSendStatus(row,v){
                let params={
                    id:row.id,
                    sendStatus:v
                };
                setSendStatus(params).then(res => {
                    if (res.status === true) {
                        this.$Message.success(res.info);
                    }
                });
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList2();
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            showSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            add() {
                let query = {type: 0}
                this.$refs.sliderDrawer.showDrawer(query);
            },
            edit(v) {
                let query = { type: 1, id: v.id};
                this.$refs.sliderDrawer.showDrawer(query);
            },
            remove(v) {
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除?",
                    onOk: () => {
                        delSlider(v.id).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.getDataList();
                            }
                        });
                    }

                });
            },
            delAll() {
                if (this.selectCount <= 0) {
                    this.$Message.warning("您还未选择要删除的数据");
                    return;
                }
                this.$Modal.confirm({
                    title: "确认删除",
                    content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
                    onOk: () => {
                        let ids = [];
                        this.selectList.forEach(function (e) {
                            ids.push(e.id);
                        });
                        delSlider(ids).then(res => {
                            if (res.status === true) {
                                this.$Message.success("删除成功");
                                this.clearSelectAll();
                                this.getDataList();
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            this.init();
        }
    }
</script>
